import sanctum from '../http/requests/auth/sanctum';
import userModifier from '../modifiers/pengguna';

const gqlUpdatePaginateDataAfterCreate = async ({
  cache,
  dataName,
  query,
  newItem,
  page,
  perPage,
}) => {
  const gqlQuery = {
    query: query.query,
    variables: {
      ...query.variables,
      page,
      perPage,
    },
  };

  let data;
  try {
    data = cache.readQuery(gqlQuery);
  } catch (error) {
    data = null;
  }
  if (!data) return;

  const merged = [newItem, ...data[dataName].data];
  const updated = merged.filter((_, index) => index < perPage);
  const addToNextPage = merged.find((_, index) => index >= perPage);

  data[dataName].data = updated;
  cache.writeQuery({
    ...gqlQuery,
    data
  });

  const hasMorePages = data[dataName].paginatorInfo.hasMorePages;
  if (hasMorePages) {
    const nextPage = page + 1;
    gqlUpdatePaginateDataAfterCreate({
      cache,
      dataName,
      query: gqlQuery,
      newItem: addToNextPage,
      page: nextPage,
      perPage,
    });
  }
};

export default {
  install(Vue) {
    Vue.prototype[
      `$${gqlUpdatePaginateDataAfterCreate.name}`
    ] = gqlUpdatePaginateDataAfterCreate;

    Vue.prototype.$objectReset = (object, resetValue = null) => {
      return Object.keys(object).reduce((accumulator, current) => {
        accumulator[current] = resetValue;
        return accumulator;
      }, {});
    };

    Vue.prototype.$getFileExtension = (file) => {
      const filenameArray = file.name.split('.');
      const extension = filenameArray[filenameArray.length - 1];
      return extension;
    };

    Vue.prototype.$user = userModifier(sanctum.getUser());
  },
};
